import { render, staticRenderFns } from "./WithdrawRecord.vue?vue&type=template&id=0540672e&scoped=true&"
import script from "./WithdrawRecord.vue?vue&type=script&lang=js&"
export * from "./WithdrawRecord.vue?vue&type=script&lang=js&"
import style0 from "./WithdrawRecord.vue?vue&type=style&index=0&id=0540672e&lang=less&scoped=true&"
import style1 from "./WithdrawRecord.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0540672e",
  null
  
)

export default component.exports